
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { LoadingComponent } from 'recupero-comunes'
import 'recupero-comunes/dist/index.css'
import { Card, Container } from "react-bootstrap";
import { obtenerConsultaCasos, obtenerExcel } from "../../store/actions/are-busqueda-casos-action";
import { useNavigate } from 'react-router-dom'

const BandejaCasosReserva = () => {

    const history = useNavigate()

    const data_areaBuscar = useSelector((state) => state.areaBusquedaCasosReducer)
    const {cfg_form32,consultaCasos,excel,myQueryStateGlobal} = data_areaBuscar
    const [loading, setLoading] = useState(false);
    const [listaGrilla, setListaGrilla] = useState('');

    //console.log("listaGrilla: ", listaGrilla);

    const dispatch = useDispatch();
    useEffect(() => {
        const lista = consultaCasos?.consultaCasos || [];

        const filtrada = lista.filter(item => item.TipoGestion === "Defensa");

        setListaGrilla(filtrada);
    }, [consultaCasos]);
    
    const handleReload = () => {

        if (consultaCasos && consultaCasos.query) {

            setLoading(true);

            // Obtener última query enviada
            let query = consultaCasos.query;

            // Ejecutar acción para obtener casos.
            dispatch(obtenerConsultaCasos(query)).then(() => {
                setLoading(false);
            });
        }
    }

    const obtenerExcelBandeja = () => {

        if (consultaCasos && consultaCasos.query) {

            setLoading(true);
            
            let query = consultaCasos.query;            
            dispatch(obtenerExcel(query));
        }
    }

    useEffect(() => {

        if (excel) {

            setLoading(false);
            
            var link = document.createElement("a");
            link.download = excel.filename;
            link.href = "data:" + excel.mimetype + ";base64," + excel.xlsxfile;
            link.click();
        }

    }, [excel]);
    const onClick = (row) => {
        const myQueryState=myQueryStateGlobal && myQueryStateGlobal
        var path = '/gestion-caso-defensa-cia';
        history(path, {
            state: {
                row,
                myQueryState,
                origen:'casosReserva'
            }
        })
    };
    const obtenerColumnas = () => {

        return [
            { 
                dataField: 'IdCaso', text: cfg_form32 ? cfg_form32.cfg_form32['consultacasos-grilla-idcaso']:'', sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },
           
            { 
                dataField: 'EstadoCaso', text: cfg_form32 ? cfg_form32.cfg_form32['consultacasos-grilla-estado']:'', sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },
            { 
                dataField: 'Responsable', text: cfg_form32 ? cfg_form32.cfg_form32['consultacasos-grilla-responsabletarea']:'', sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },
            { 
                dataField: 'FechaAsignacion', text: cfg_form32 ? cfg_form32.cfg_form32['consultacasos-grilla-fechaasigcaso']:'', 
                sort: true, 
                sortFunc: (a, b, order, dataField, rowA, rowB) => {
                    if (order === 'asc') return stringDate2Time(a) - stringDate2Time(b);
                    else return stringDate2Time(b) - stringDate2Time(a);
                }, 
                headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },
            { 
                dataField: 'Siniestro', text: cfg_form32 ? cfg_form32.cfg_form32['consultacasos-grilla-siniestro']:'', sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },
            { 
                dataField: 'FechaSiniestro', text: cfg_form32 ? cfg_form32.cfg_form32['consultacasos-grilla-fechasiniestro']:'', sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },
            { 
                dataField: 'TipoGestion', text: cfg_form32 ? cfg_form32.cfg_form32['consultacasos-grilla-tipogestion']:'', 
                sort: true, 
                sortFunc: (a, b, order, dataField, rowA, rowB) => {
                    if (order === 'asc') return stringDate2Time(a) - stringDate2Time(b);
                    else return stringDate2Time(b) - stringDate2Time(a);
                }, 
                headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },
            { 
                dataField: 'SituacionSiniestro', text: cfg_form32 ? cfg_form32.cfg_form32['consultacasos-grilla-situacion']:'', sort: true, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            }, 
            {
                dataField: 'PatenteAsegurado', text:cfg_form32 ? cfg_form32.cfg_form32['consultacasos-grilla-patenteaseg']:'', headerAlign: 'center', align: 'center'
                ,headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },
            {
                dataField: 'PatenteTercero', text: cfg_form32 ? cfg_form32.cfg_form32['consultacasos-grilla-pattero']:'',  headerAlign: 'center', align: 'center'
                , headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
                , headerStyle:{color:'white', backgroundColor:'#7594C1'}
            },           
            {
                dataField: 'accion',
                text: cfg_form32 ? cfg_form32.cfg_form32['consultacasos-grilla-accion'] : '',
                isDummyField: true,
                headerAlign: 'center',
                align: 'center',

                formatter: (cell, row) => {
                    if (row.TipoGestion !== "Defensa") return null;

                    return (
                    <div>
                        <Button
                        type="button"
                        variant="subir me-md-2"
                        size="sm"
                        onClick={() => onClick(row)}
                        >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            fill="currentColor"
                            className="bi bi-search"
                            viewBox="0 0 16 16"
                        >
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                        </svg>
                        </Button>
                    </div>
                    );
                },

                headerStyle: {
                    color: 'white',
                    backgroundColor: '#7594C1',
                    verticalAlign: 'middle'
                }
            }
        ];
    }

    const stringDate2Time = (date) => {
        date = date.split("-");
        return new Date( date[2], date[1] - 1, date[0]).getTime();
    }

    return (
        <div>
            <style type='text/css'>
        {`
    .btn-subir {
      background-color: #00aeab;
      color: #FFFFFF;   
      height:40px;

    }
    .btn-subir:hover{
        background-color:#01cec8;
        color: #FFFFFF;
        
    } 
    
    `}
    </style>
 
            <LoadingComponent show={loading} />
            { cfg_form32 ? 
            <Card >
                <Card.Header
                className='mt-0 mb-0'
                as='h6'
                style={{ backgroundColor: '#4F517A', color: 'white', textAlign:'center' }}
                >
                {cfg_form32
                    ? `${cfg_form32.cfg_form32['consultacasos-title-grilla']} (${consultaCasos && consultaCasos.consultaCasos !==undefined ? consultaCasos.consultaCasos.length : 0})`
                    : ''} 
                </Card.Header>
            <ToolkitProvider search bootstrap4 keyField="Id" 
                data={ listaGrilla ? listaGrilla : [] } 
                columns={ obtenerColumnas() } defaultSorted={ [{ dataField: 'Id', order: 'asc' }] }>
                { 
                props =>                   
                    <div>
                        
                        <Row>
                            <Col md={4} className="d-grid gap-2 d-md-flex justify-content-md-start mt-2 mb-2">
                                <Button className="mx-2" type="button" variant="success" size="sm" onClick={() => { obtenerExcelBandeja() }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-file-earmark-excel" viewBox="0 0 16 16">
                                    <path d="M5.884 6.68a.5.5 0 1 0-.768.64L7.349 10l-2.233 2.68a.5.5 0 0 0 .768.64L8 10.781l2.116 2.54a.5.5 0 0 0 .768-.641L8.651 10l2.233-2.68a.5.5 0 0 0-.768-.64L8 9.219l-2.116-2.54z"/>
                                    <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>
                                    </svg>
                                </Button>
                            </Col>                           
                            <Col md={8} className="d-grid gap-2 d-md-flex justify-content-md-end mt-2 mb-2">
                                
                                <Form.Control placeholder="Buscar en la grilla" className="w-25" onChange={(e) => { props.searchProps.onSearch(e.target.value) }}/>
                                <Button className="mx-2" type="button" variant="outline-info" size="sm" onClick={() => { handleReload() }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                                    <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                                    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                                    </svg>
                                </Button>
                               
                            </Col>                           
                        </Row>                        
                        <BootstrapTable { ...props.baseProps } headerWrapperClasses="table-secondary" pagination={ paginationFactory() } noDataIndication={<div className="text-center">No hay registros encontrados</div>} />
                    </div>
                }
            </ToolkitProvider>
            </Card>
     
            : null }
        </div>
    );
}

export default BandejaCasosReserva;
